import React, {useState,useEffect} from "react";
import database from '../firebase';
import "./Album.css";
import AlbumsCollection from "./Albums.js"


const db = database.firestore();
const storage = database.storage();

export default  function AlbumUser(props) {
    const [ID] = useState(props.ID);
    const [English, setEnglish] = useState(true);
    const [Loading, setLoading] = useState(true);
    const [Albums, setAlbums] = useState(false);

    const [Message, seMessage] = useState("haven't chosen an image");
    const [Album, setAlbum] = useState([]);
    const [images, setImages] = useState([]);
    const [progress, setProgress] = useState(0);
    const [title, setTitle] = useState("");
    const [Refresh, setRefresh] = useState(0);
    const [Move, setMove] = useState(true);

    useEffect(() =>  {
        //照片集
        db.collection("users").doc(ID).collection("Album").get().then(querySnapshot=>{
            const data = querySnapshot.docs.map(doc=>doc.data());
            setAlbum(data);
            if(data.length>0)setAlbums(true); 
            setLoading(false)
        });
        setProgress(0);
        setImages([]);
        setTitle("");
    },[ID,Refresh])

    useEffect(()=>{
        if(images.length>0){
            if (English === true) seMessage("image selected")
            else seMessage("已选择图片")
        }else{
            if (English === true) seMessage("haven't chosen an image")
            else seMessage("还未选择图片")
        }
    },[images,English])

    const updateImage = (e)=>{
        setImages([]);
        for (let i=0; i<e.target.files.length; i++){
            const newImage = e.target.files[i];
            newImage["id"] = Math.random();
            setImages((prevState) => [newImage, ...prevState]);
        }
    };

    const handleUpload =(e)=>{
        e.preventDefault();

        db.collection("users").doc(ID).collection("Album").doc(title).set({
            id: title,
        });

        var progress_ = 0;
        Promise.all(images.map(async(image) =>{
            await storage.ref(ID+"/Album/"+title+"/"+image.name).put(image).then(async()=>{

                await storage.ref(ID).child("/Album/"+title+"/"+image.name).getDownloadURL().then((url)=>{
                    const ref = db.collection("users").doc(ID).collection("Album").doc(title).collection("images").doc();
                    ref.set({
                        image: url,
                        id: ref.id,
                    })
                })
            })
            progress_ += 100/images.length;
            setProgress(progress_);
        }))
    }

    const ChangeToChinese =()=>{
        if (Move === true){
            if(Message === "haven't chosen an image"){
                seMessage("还未选择图片")
            }else if (Message === "image selected"){
                seMessage("已选择图片")
            }
            setEnglish(false);

            setMove(false);
            setTimeout(()=>{
                setMove(true);
            },500)
        }
    }

    const ChangeToEnglish =()=>{
        if (Move === true){
            if(Message === "还未选择图片"){
                seMessage("haven't chosen an image")
            }else if (Message === "已选择图片"){
                seMessage("image selected")
            }
            setEnglish(true);

            setMove(false);
            setTimeout(()=>{
                setMove(true);
            },500)
        }
    }

    useEffect(()=>{
        if (progress > 99.9){
            if (Albums===false)setAlbums(true);
            var t = Refresh+1;
            setRefresh(t);
        }
    },[progress,Albums]) 

 
    return(
        <div>
        {Loading? (
            <>
            <h1> Loading </h1>
            </>
        ):(
            <>
            {English?(    
                <>
                <div className="AlbumUser">
                    <h1> Album </h1>
                    <div className="AlbumUser-Language" onClick={ChangeToChinese}> <h3>中文</h3></div>

                    <div> 
                    {Albums?(
                        <div className="AlbumUser-Something">
                            <form onSubmit={handleUpload} className="AlbumUser-create">
                                Title：<input type="text" required value={title}
                                    placeholder="Unique Title"
                                    onChange={(e)=> setTitle(e.target.value)} ></input><br/>

                                <input type="file" className="AlbumUser-SelectImage" required
                                    multiple onChange={updateImage} id="AlbuminputImage"></input>
                                
                                <label htmlFor="AlbuminputImage"><h6>Select Image</h6></label>
                                <h5>{Message}</h5>
                                <progress value={progress} max="100"/><br/>

                                <button type="submit">Upload</button>
                            </form>

                            <div>
                                {Album.map(each => <AlbumsCollection
                                    key = {each.id}
                                    id = {each.id}
                                    ID = {ID}
                                    State = {"Delete"}
                                />)}
                            </div>


                        </div>
                    ):(
                        <div className="AlbumUser-Nothing">
                            <h3>You don't have an album</h3>
                            <h4>Create an album below</h4>

                            
                            <form onSubmit={handleUpload} className="AlbumUser-create">
                                Title：<input type="text" required value={title}
                                    placeholder="Unique Title"
                                    onChange={(e)=> setTitle(e.target.value)} ></input><br/>

                                <input type="file" className="AlbumUser-SelectImage" required
                                    multiple onChange={updateImage} id="AlbuminputImage"></input>
                                
                                <label htmlFor="AlbuminputImage"><h6>Select Image</h6></label>
                                <h5>{Message}</h5>
                                <progress value={progress} max="100"/><br/>

                                <button type="submit">Upload</button>
                            </form>
                        </div>
                    )
                    }
                    </div>
                </div>
                </>
            ):(
                <>
                <div className="AlbumUser">
                    <h1> 相册</h1>
                    <div className="AlbumUser-Language" onClick={ChangeToEnglish}> <h3>English</h3></div>

                    <div> 
                    {Albums?(
                        <div className="AlbumUser-Something">
                            <form onSubmit={handleUpload} className="AlbumUser-create">
                                主题：<input type="text" required value={title}
                                    placeholder="独特的主题"
                                    onChange={(e)=> setTitle(e.target.value)} ></input><br/>

                                <input type="file" className="AlbumUser-SelectImage" required
                                    multiple onChange={updateImage} id="AlbuminputImage"></input>
                                
                                <label htmlFor="AlbuminputImage"><h6>选择图片</h6></label>
                                <h5>{Message}</h5>
                                <progress value={progress} max="100"/><br/>

                                <button type="submit">上传</button>
                            </form>

                            <div>
                                {Album.map(each => <AlbumsCollection
                                    id = {each.id}
                                    English={English}
                                    ID = {ID}
                                    State = {"Delete"}
                                />)}
                            </div>
                        </div>
                    ):(
                        <div className="AlbumUser-Nothing">
                            <h3>你还没有相册集</h3>
                            <h4>在下方创建一个相册集</h4>

                            
                            <form onSubmit={handleUpload} className="AlbumUser-create">
                                主题：<input type="text" required value={title}
                                    placeholder="独特的主题"
                                    onChange={(e)=> setTitle(e.target.value)} ></input><br/>

                                <input type="file" className="AlbumUser-SelectImage" required
                                    multiple onChange={updateImage} id="AlbuminputImage"></input>
                                
                                <label htmlFor="AlbuminputImage"><h6>选择图片</h6></label>
                                <h5>{Message}</h5>
                                <progress value={progress} max="100"/><br/>

                                <button type="submit">上传</button>
                            </form>
                        </div>
                    )
                    }
                    </div>
                </div>
                </>
            )}
            </>
        )}
        </div>
    )
}